import { EditIcon, Link } from '@dreryk/react-components';

import { GuardianModalFormBean } from '../../../common/GuardianModal/GuardianModal.types';

import { GuardianDeleteIcon } from './GuardianDeleteIcon';
import { StyledActionsCell } from './StyledActionsCell';

type ActionsCellProps = {
   readonly onEdit: () => void;
   readonly onDelete: (guardian: GuardianModalFormBean) => void;
   readonly guardian: GuardianModalFormBean;
};

export const ActionsCell = (props: ActionsCellProps): JSX.Element => (
   <StyledActionsCell>
      <Link onClick={() => props.onEdit()} icon={<EditIcon />} testId={'update'} />
      <GuardianDeleteIcon guardian={props.guardian} onDelete={props.onDelete} />
   </StyledActionsCell>
);
